import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import { localizedPath } from '../seo/routes';

const CtaSection: React.FC = () => {
  const { translations, language } = useLanguage();
  
  return (
    <section className="py-20 bg-white" id="cta">
      <div className="container-custom">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-navy mb-6">{translations.cta.title}</h2>
          <p className="text-gray-700 mb-10 text-lg">
            {translations.cta.text}
          </p>
          
          <div className="flex flex-col md:flex-row justify-center gap-6">
            <Link to={`${localizedPath('contact', language)}?booking=true`} className="btn btn-primary">
              {translations.cta.bookButton}
            </Link>
            <a href="tel:+34603319648" className="btn bg-light-blue text-navy hover:bg-navy hover:text-white">
              {translations.cta.callButton}
            </a>
          </div>
          
          <p className="mt-8 text-gray-600">
            {translations.cta.visitInfo}
          </p>
        </div>
      </div>
    </section>
  );
};

export default CtaSection; 